import Vue from "vue";
import VeeValidate from "vee-validate";
import {dict} from "@/validation/validationDictionary";

import {
  allowedCategoriesRule, 
  bicRule, 
  ibanRule, 
  loginNameRule, 
  truthyRule,
  emailDeVRule
} from "@/validation/customRules";

Vue.use(VeeValidate, {
  inject: false
});

VeeValidate.Validator.localize('de', dict);

VeeValidate.Validator.extend("categoriesAllowed", allowedCategoriesRule);
VeeValidate.Validator.extend('truthy', truthyRule);
VeeValidate.Validator.extend('iban-validator', ibanRule);
VeeValidate.Validator.extend('bic-validator', bicRule);
VeeValidate.Validator.extend('login-name', loginNameRule);
VeeValidate.Validator.extend('email-dev', emailDeVRule);